import { SimpleCheckbox } from '@AMIEWEB/Unit/Common/SimpleCheckbox';
import { Button, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { useAddEditReferenceStyle } from './AddEditReference.style';
import { useTranslation } from 'react-i18next';

const ageSpecificList = [
  { ageID: 1, ageType: 'Newborns/Neonates' },
  { ageID: 2, ageType: 'Infants' },
  { ageID: 3, ageType: 'Toddlers' },
  { ageID: 4, ageType: 'Preschoolers' },
  { ageID: 5, ageType: 'Older Children' },
  { ageID: 6, ageType: 'Adolescents' },
  { ageID: 7, ageType: 'Young Adults' },
  { ageID: 8, ageType: 'Middle Adults' },
  { ageID: 9, ageType: 'Older Adults/Geriatrics' },
];

const AgeSpecificCompetencies = ({ ageCompetency = [], disabled }: { ageCompetency: any; disabled: boolean }) => {
  const { t } = useTranslation();
  const { classes } = useAddEditReferenceStyle();
  return (
    <Paper variant="outlined" square>
      <Grid container direction={'column'} columnSpacing={4} m={4} mt={3} width={'max-content'}>
        <Typography component={'h4'} className={classes.AdditionalInfoTitle}>
          {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.ageSpecificCompetencies')}
        </Typography>
        <Grid container py={2} ml={-1.5}>
          <Grid item>
            <Button
              className="select-all-button"
              aria-label="select-all-button"
              variant="text"
              color="primary"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              onClick={() => {}} //To-Do: Implement OnClick functionality
              disabled={disabled}
            >
              {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.selectAll')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              className="clear-all-button"
              aria-label="clear-all-button"
              variant="text"
              color="primary"
              disableRipple
              disableFocusRipple
              disableTouchRipple
              onClick={() => {}} //To-Do: Implement OnClick functionality
              disabled={disabled}
            >
              {t('candidate.workExperience.addEditReference.referenceAdditionalInfo.clearAll')}
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          direction={'column'}
          flexWrap="nowrap"
          rowSpacing={3}
          ml={2}
          sx={{ maxHeight: 260, overflowY: 'auto' }}
        >
          {ageSpecificList?.map(item => (
            <Grid item key={item?.ageID}>
              <SimpleCheckbox
                isChecked={ageCompetency?.some(el => el.ageType === item.ageType)}
                handleChecked={() => {}} //To-Do: Implement onChange functionality
                checkboxLabel={item?.ageType}
                checkboxName={item?.ageType}
                id={item?.ageID?.toString()}
                isdisabled={disabled}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(AgeSpecificCompetencies);
